import { Mail, MessageSquare, Phone, Smartphone } from 'lucide-react';
import { Badge } from '../ui/badge';
import type { Kontaktweg } from '../../lib/api/stammdaten';

const ARTEN: Record<string, { label: string; Icon: typeof Mail }> = {
  email: { label: 'E-Mail', Icon: Mail },
  mobil: { label: 'Mobil', Icon: Smartphone },
  festnetz: { label: 'Festnetz', Icon: Phone },
  sms: { label: 'SMS', Icon: MessageSquare },
};

/**
 * Kontaktwege zum Lesen — dieselben Arten wie im {@link KontaktwegeEditor}.
 *
 * Die Profilseite zeigte die Kontaktwege eines Schülerprofils gar nicht; wer eine
 * eigene Adresse eintragen wollte, fand keinen Ort dafür (T-0289).
 */
export default function KontaktwegeListe({
  wege,
  leer,
}: Readonly<{ wege: Kontaktweg[]; leer: string }>) {
  const sichtbar = wege.filter((weg) => String(weg.value || '').trim() !== '');
  if (sichtbar.length === 0) {
    return <p className="text-sm text-muted-foreground">{leer}</p>;
  }
  return (
    <ul className="space-y-2">
      {sichtbar.map((weg, index) => {
        const art = ARTEN[String(weg.type || '').toLowerCase()];
        const Icon = art?.Icon ?? MessageSquare;
        return (
          <li key={`${weg.type}-${weg.value}-${index}`} className="flex flex-wrap items-center gap-2 rounded-md border p-3">
            <Icon className="h-4 w-4 shrink-0 text-muted-foreground" aria-hidden />
            <span className="w-20 shrink-0 text-xs text-muted-foreground">{art?.label ?? weg.type}</span>
            <span className="min-w-0 flex-1 break-all">{weg.value}</span>
            {weg.officeContactAllowed === false ? (
              <Badge variant="outline" className="border-amber-300 bg-amber-50 text-amber-800">
                Büro darf nicht kontaktieren
              </Badge>
            ) : null}
          </li>
        );
      })}
    </ul>
  );
}
